import React, { useState } from 'react';
import Navlogo from '../../resources/eaciit-logo.svg';
import './footer.scss';
import GetStart from '../GetStart/index.jsx';

const FooterComponent = () => {
	const [isHome, setIsHome] = useState();

	const routeChange = (path) => {
		if (window) {
			let pathName = '/' + path;
			let withHash = pathName.includes('#');

			//check if path contain hash
			if (window.location.hash && withHash) {
				let parentPathName = pathName.split('#')[0].replace(/\//g, ''); //get main path target without slash
				let windowPathName = window.location.pathname.replace(/\//g, ''); //get main path current location without slash

				if (parentPathName === windowPathName) {
					//compare path target with current path
					window.location = pathName; // change current path
					window.location.reload(true); // need to reload the page for pointing target div
				} else {
					window.location = pathName;
				}
			} else {
				window.location = pathName;
			}
		}
		// Safety check for navBar existence
		const navBar = document.getElementById('navBar');
		if (navBar) {
			navBar.scrollIntoView();
		}
	};

	React.useEffect(() => {
		if (typeof document !== 'undefined') {
			let isHome = window.location.pathname.includes('home') || "/" ;
			setIsHome(isHome);
		}
	}, []);

	return (
		<>
			<div className='footer'>
				{!isHome && (
					<div className='footer-get-started'>
						<GetStart />
					</div>
				)}

				<div className='section-bottom'>
					{/* Column 1: Logo and Description */}
					<div className='section-footer-group footer-group-logo'>
						<img className='footer-img' src={Navlogo} alt='footer-logo' />
						<div className='footer-desc' onClick={() => routeChange('home')}>
							Continuous Enterprise<br/>
							Performance <br/>Management and <br/>Optimization
						</div>
					</div>

					{/* Column 2: Product */}
					<div className='section-footer-group'>
						<div className='footer-head'>Product</div>
						<div className='footer-content' onClick={() => routeChange('ai-tools')}>
							AskEPM
						</div>
						<div className='footer-content' onClick={() => routeChange('enterprise-control-tower')}>
							Enterprise Control Tower
						</div>
						<div className='footer-content' onClick={() => routeChange('cloud-fpa')}>
							Cloud FP&A, Continuous MIS
						</div>
						<div className='footer-content' onClick={() => routeChange('pre-build-applications')}>
							Pre-Built Applications
						</div>
						<div className='footer-content' onClick={() => routeChange('product')}>
							ECFM
						</div>
						<div className='footer-content' onClick={() => routeChange('databrowser')}>
							Data Browser
						</div>
						<div className='footer-content' onClick={() => routeChange('data-quality-tool')}>
							Data Quality Tool
						</div>
					</div>

					{/* Column 3: Platform */}
					<div className='section-footer-group'>
						<div className='footer-head'>Platform</div>
						<div className='footer-content' onClick={() => routeChange('technology')}>
							By Technology
						</div>
						<div className='footer-content' onClick={() => routeChange('features')}>
							By Capability
						</div>
					</div>

					{/* Column 4: Solutions */}
					<div className='section-footer-group'>
						<div className='footer-head'>Solutions</div>
						<div className='footer-content' onClick={() => routeChange('keyfocus')}>
							By Function
						</div>
						<div className='footer-content' onClick={() => routeChange('industry')}>
							By Industry
						</div>
					</div>

					{/* Column 5: Resources */}
					<div className='section-footer-group'>
						<div className='footer-head'>Resources</div>
						<div className='footer-content' onClick={() => routeChange('resources')}>
							Customer Stories
						</div>
						<div className='footer-content' onClick={() => routeChange('recognition')}>
							Recognition
						</div>
					</div>

					{/* Column 6: Company */}
					<div className='section-footer-group'>
						<div className='footer-head'>Company</div>
						<div className='footer-content' onClick={() => routeChange('company')}>
							About Us
						</div>
						<div className='footer-content' onClick={() => routeChange('home')}>
							Why EACIIT
						</div>
						<div className='footer-content' onClick={() => routeChange('company#CompanySectionTwoTeam')}>
							Meet the Team & Advisors
						</div>
						<div className='footer-content' onClick={() => routeChange('contact')}>
							Contact Us
						</div>
					</div>
				</div>

				{/* Unchanged bottom footer */}
				<div className='footer-company'>
					<span>2014 © EACIIT Vyasa PTE. LTD | All rights Reserved</span>
				</div>
			</div>
		</>
	);
};

export default FooterComponent;